/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * MovingWorlds API
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type { Language } from './platformapi.schemas';

import getLanguagesMutator from '../custom-axios-instance';

/**
 * Retrieves a list of languages
 * @summary Get Languages
 */
export const getLanguages = (signal?: AbortSignal) => {
  return getLanguagesMutator<Language[]>({
    url: `${import.meta.env['VITE_API_HOST']}/languages/languages`,
    method: 'GET',
    signal,
  });
};

export const getGetLanguagesQueryKey = () => {
  return [`${import.meta.env['VITE_API_HOST']}/languages/languages`] as const;
};

export const getGetLanguagesQueryOptions = <
  TData = Awaited<ReturnType<typeof getLanguages>>,
  TError = void,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLanguages>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetLanguagesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLanguages>>> = ({ signal }) =>
    getLanguages(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getLanguages>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetLanguagesQueryResult = NonNullable<Awaited<ReturnType<typeof getLanguages>>>;
export type GetLanguagesQueryError = void;

export function useGetLanguages<TData = Awaited<ReturnType<typeof getLanguages>>, TError = void>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLanguages>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLanguages>>,
          TError,
          Awaited<ReturnType<typeof getLanguages>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetLanguages<TData = Awaited<ReturnType<typeof getLanguages>>, TError = void>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLanguages>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLanguages>>,
          TError,
          Awaited<ReturnType<typeof getLanguages>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetLanguages<TData = Awaited<ReturnType<typeof getLanguages>>, TError = void>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLanguages>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Languages
 */

export function useGetLanguages<TData = Awaited<ReturnType<typeof getLanguages>>, TError = void>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getLanguages>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetLanguagesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
